<div class="wrapper" [ngClass]="{'menu-layout-overlay':isOVerlay(),
                                'menu-layout-static':isStatic(),
                                'layout-light':app.lightMenu,
                                'sidebar-inactive-l':menuInactiveDesktop,
                                'sidebar-active-m':menuActiveMobile,
                                'p-ripple-disabled': !app.ripple, 'p-input-filled': app.inputStyle === 'filled'}">
    <app-topbar></app-topbar>

    <div class="sidebar" (click)="onMenuClick()">
        <div class="sidebar-scroll-content">
            <!--            <div class="logo" routerLink="/" style="outline: none; cursor: pointer;">-->
            <!--&lt;!&ndash;                <img [src]="'assets/layout/images/omega-' + (app.lightMenu ? 'black.svg' : 'white.svg')" alt="" width="113">&ndash;&gt;-->
            <!--                <img src="assets/layout/images/profile.png" alt="" width="113">-->
            <!--            </div>-->
            <!--            <div class="profile">-->
            <!--&lt;!&ndash;                <img src="assets/layout/images/profile.png" alt=""/>&ndash;&gt;-->
            <!--                <a id="profile-button" href="#" (click)="toggleProfile($event)">-->
            <!--                    <span class="username">{{userName$| async | titlecase}}</span>-->
            <!--                    <i class="pi pi-fw pi-cog"></i>-->
            <!--                </a>-->
            <!--                <ul [@submenu]="profileActive ? 'visible' : 'hidden'">-->
            <!--                    <li><a href="#"><i class="pi pi-fw pi-sliders-h"></i><span>Account</span></a></li>-->
            <!--                    <li><a href="#"><i class="pi pi-fw pi-bell"></i><span>Notifications</span><span-->
            <!--                        class="menu-badge">2</span></a></li>-->
            <!--                    <li><a href="#"><i class="pi pi-fw pi-sign-out"></i><span>Logout</span></a></li>-->
            <!--                </ul>-->
            <!--            </div>-->
            <div class="flex justify-content-center align-items-center mt-5 flex-column">
<!--                <div class="mb-1">-->
<!--                    <img src="assets/layout/images/logo.png">-->
<!--                </div>-->
                <div class="p-3 golfdigg-text {{logoClass}}">GOLFDIGG</div>
            </div>

            <br>
            <app-menu></app-menu>

            <!--            <div class="flex justify-content-evenly">-->
            <!--                <img src="assets/layout/images/cat1.png" width="65" alt="">-->
            <!--                <div class="p-3">-->
            <!--                    <h3 class="text-blue-500 inline">A</h3>-->
            <!--                    <h3 class="text-white inline">U</h3>-->
            <!--                </div>-->
            <!--            </div>-->

        </div>
    </div>
    <div class="main">
        <div class="pb-4">
            <xng-breadcrumb></xng-breadcrumb>
        </div>
        <router-outlet></router-outlet>
    </div>

    <app-config></app-config>
    <div class="footer">
        <!--        <img src="assets/layout/images/logo-colored.png" alt="" width="32">-->
        <span class="footer-text">Golfdigg 2022 {{version}}</span>
    </div>

</div>
